class ContextualSidebar {
  constructor() {
    this.setup();
    this.listen();
  }

  setup() {
    this.sidebars = $('.contextual-sidebar');
    this.container = $('.rpm-content-wrapper');
    if (this.hasSidebar()) {
      this.open();
    }
  }

  refresh() {
    this.setup();
  }

  hasSidebar() {
    return this.sidebars.length > 0;
  }

  open() {
    this.state = 'opened';
    this.sidebars
      .removeClass('open two wide column closed')
      .addClass('three wide column');
    this.sidebars.height('auto');
    this.sidebars
      .find('i.angle.double.left.icon')
      .removeClass('angle double left')
      .addClass('angle double right');
    this.container
      .removeClass('thirteen wide column with-sidebar')
      .addClass('ten wide column');
  }

  close() {
    this.state = 'closed';
    this.sidebars.addClass('closed').removeClass('open two wide column');
    this.sidebars
      .find('i.angle.double.right.icon')
      .removeClass('angle double right')
      .addClass('angle double left');
    this.sidebars.height(this.container.find('#main-content').height());
    this.container
      .removeClass('ten wide column')
      .addClass('thirteen wide column with-sidebar');
  }

  listen() {
    $('a.sidebar-toogle').on('click', () => {
      if (this.state === 'opened') {
        this.close();
      } else {
        this.open();
      }
    });
  }
}

module.exports = ContextualSidebar;
